<input class="fn-color-picker-border" readonly [colorPicker]="value" [cpDisabled]="isDisabled" [style.background]="value"
  [cpOKButton]="showOkBtn" [cpCancelButton]="showCancelBtn" (colorPickerSelect)="changeColor($event)"
  [cpOutputFormat]="outputFormat" [cpSaveClickOutside]="isSaveClkOutside" [cpDisableInput]="isDisableInput"
  [cpOKButtonClass]="okButtonClass" [cpCancelButtonClass]="cancelButtonClass" />
